import { InjectionToken } from '@angular/core';

export interface SntServerErrorsModuleConfig {
  excludeKeys?: string[];
}

export const SERVER_ERRORS_CONFIG_TOKEN = new InjectionToken<SntServerErrorsModuleConfig>('config');
